import { useEffect, useRef } from 'react';
import { Body, Box } from 'dma-ui-kit';
import styled from 'styled-components';

const Container = styled(Box)`
  margin-bottom: 20px;
  max-width: 1250px;
  padding: 0 12px;

  @media (min-width: 768px) {
    padding: 0 24px;
  }

  @media (min-width: 1024px) {
      padding: 0 48px;
  }    

  & h2 {
    margin: 5px 0;
  }
  & h5 {
    margin: 5px 0;
  }
`;
const ContentText = props => {
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current && props.paragraph.attributes.field_text.processed) {
            const html = props.paragraph.attributes.field_text.processed;
            contentRef.current.innerHTML = html;

            // Extract and execute script tags
            const scripts = contentRef.current.querySelectorAll('script');
            scripts.forEach(oldScript => {
                const newScript = document.createElement('script');
                // Copy all attributes
                Array.from(oldScript.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                });
                // Copy script content
                newScript.textContent = oldScript.textContent;
                // Replace old script with new one to trigger execution
                oldScript.parentNode.replaceChild(newScript, oldScript);
            });
        }
    }, [props.paragraph.attributes.field_text.processed]);

    return (
        <Container>
            <Body>
                <span ref={contentRef} />
            </Body>
        </Container>
    );
};

export default ContentText;
